module.exports = __webpack_public_path__ + "4c9b473eaa15c153e748cbe3cdd58832.png";